import * as apiCommon from '@/api/apiCommon'

// 资源库中新
const apiName = '/webapi/resource'

// 资源列表
export function index(data) {
	return apiCommon.index(apiName + '/index', data)
}
// read
export function read(data) {
	return apiCommon.index(apiName + '/read', data)
}



